import { AppSettings } from '../proyect.conf';
import { Injectable } from '@angular/core';
import * as dev from '../environments/environment.dev';
import * as test from '../environments/environment.test';
import * as preprod from '../environments/environment.preprod';
import * as prod from '../environments/environment.prod';
import * as soporte from '../environments/environment.soporte';
import * as lideres from '../environments/environment.lideres';
import * as wompi from '../environments/environment.wompi';

interface Config {
  AMBIENTE: string;
  API_URL: string;
  SERVICIO_REPORTES: string;
  PUERTO: string;
  PROTOCOLO: string;
  NOTIFICADOR: string;
  NOTIFICADOR_STOMP: string;
  DOBLE_AUTENTICACION: string;
  GOOGLE_AUTH_CLIENT_ID: string;
  GOOGLE_MAPS_KEY: string;
  GOOGLE_ANALYTICS_ID: string;
  TIEMPO_INACTIVIDAD: string;
  UNICA_SESSION_USUARIO: string;
  URL_CREDITO_DIGITAL: string;
  LOGGIN_LEVEL: string;
}

export function actualizarSettings( objeto: Config ) {
  AppSettings.nameEnviroment = objeto.AMBIENTE || AppSettings.nameEnviroment;
  AppSettings.urlNotificador = objeto.NOTIFICADOR || AppSettings.urlNotificador;
  AppSettings.notificadorStomp = objeto.NOTIFICADOR_STOMP || AppSettings.notificadorStomp;
  AppSettings.rutReportes = objeto.SERVICIO_REPORTES || AppSettings.rutReportes;
  AppSettings.rutDobleValidacion = objeto.DOBLE_AUTENTICACION || AppSettings.rutDobleValidacion;
  AppSettings.idGoogleCliente = objeto.GOOGLE_AUTH_CLIENT_ID || AppSettings.idGoogleCliente;
  AppSettings.googleMapsKey = objeto.GOOGLE_MAPS_KEY || AppSettings.googleMapsKey;
  AppSettings.googleAnalyticsId = objeto.GOOGLE_ANALYTICS_ID || AppSettings.googleAnalyticsId;
  AppSettings.unicaSessionUsuario = objeto.UNICA_SESSION_USUARIO ? objeto.UNICA_SESSION_USUARIO === '1' : AppSettings.unicaSessionUsuario;
  AppSettings.tiempoInactividad = objeto.TIEMPO_INACTIVIDAD ? Number( objeto.TIEMPO_INACTIVIDAD ) : AppSettings.tiempoInactividad;
  if ( objeto.PROTOCOLO && objeto.API_URL && objeto.PUERTO ) {
    AppSettings.rutServicios = `${objeto.PROTOCOLO}://${objeto.API_URL}:${objeto.PUERTO}`;
    AppSettings.rutServiciosRG = `${AppSettings.rutServicios}/negociorg`;
    AppSettings.rutServiciosASI = `${AppSettings.rutServicios}/negocioasi`;
    AppSettings.rutServiciosTER = `${AppSettings.rutServicios}/negocioter`;
    AppSettings.rutServiciosAPL = `${AppSettings.rutServicios}/negocioapl`;
    AppSettings.rutServiciosDOR = `${AppSettings.rutServicios}/negociodor`;
    AppSettings.rutServiciosDESPENSAS = `${AppSettings.rutServicios}/negociodespensas`;
    AppSettings.rutServiciosHOJAEVALUACION = `${AppSettings.rutServicios}/negociohojaevaluacion`;
    AppSettings.rutServiciosAUTOGES = `${AppSettings.rutServicios}/negocioautogestionado`;
    AppSettings.rutServiciosALIADOS = `${AppSettings.rutServicios}/negocioaliados`;
    AppSettings.rutServiciosPOLITICA = `${AppSettings.rutServicios}/negociopoliticas`;
    AppSettings.rutServiciosINTE = `${AppSettings.rutServicios}/negociointegraciones`;
    AppSettings.rutServiciosPROPER = `${AppSettings.rutServicios}/negocioprosperfil`;
    AppSettings.rutServiciosADJ = `${AppSettings.rutServicios}/negocioadj`;
    AppSettings.rutServiciosGESTORES = `${AppSettings.rutServicios}/negociogestores`;
    AppSettings.rutMilitarizada = `${objeto.API_URL}:${objeto.PUERTO}`;
    AppSettings.rutDesmilitarizada = `${AppSettings.rutMilitarizada}/auth`;
    AppSettings.rutFacetec = `${AppSettings.rutServicios}/facetec`;
  }
}

export function actualizarSettingsAmbiente( objeto: Config ) {
  if ( objeto && objeto.AMBIENTE ) {
    let ambiente = null;
    switch ( objeto.AMBIENTE.toUpperCase() ) {
      case 'DEV':
        ambiente = dev;
        break;
      case 'TEST':
        ambiente = test;
        break;
      case 'PREPRODUCCION':
        ambiente = preprod;
        break;
      case 'PRODUCCION':
        ambiente = prod;
        break;
      case 'PRODUCCIONDEFAULT':
        ambiente = lideres;
        break;
      case 'SOPORTE':
        ambiente = soporte;
        break;
      case 'WOMPI':
        ambiente = wompi;
        break;
    }
    if ( ambiente && ambiente.environment ) {
      const environment = ambiente.environment;
      AppSettings.produccion = environment.production;
      AppSettings.nameEnviroment = environment.nameEnviroment;
      AppSettings.urlNotificador = environment.notificador;
      AppSettings.rutServiciosRG = environment.endpoint + '/negociorg';
      AppSettings.rutServiciosASI = environment.endpoint + '/negocioasi';
      AppSettings.rutServiciosTER = environment.endpoint + '/negocioter';
      AppSettings.rutServiciosAPL = environment.endpoint + '/negocioapl';
      AppSettings.rutServiciosDOR = environment.endpoint + '/negociodor';
      AppSettings.rutServiciosDESPENSAS = environment.endpoint + '/negociodespensas';
      AppSettings.rutServiciosHOJAEVALUACION = environment.endpoint + '/negociohojaevaluacion';
      AppSettings.rutServiciosAUTOGES = environment.endpoint + '/negocioautogestionado';
      AppSettings.rutServiciosALIADOS = environment.endpoint + '/negocioaliados';
      AppSettings.rutServiciosPOLITICA = environment.endpoint + '/negociopoliticas';
      AppSettings.rutServiciosINTE = environment.endpoint + '/negociointegraciones';
      AppSettings.rutServiciosPROPER = environment.endpoint + '/negocioprosperfil';
      AppSettings.rutServiciosADJ = `${environment.endpoint}/negocioadj`;
      AppSettings.rutServiciosGESTORES = `${environment.endpoint}/negociogestores`;
      AppSettings.rutServiciosSarlaft = environment.endpoint + '/negociosarlaft';
      AppSettings.rutNegocioreglas = environment.endpoint + '/negocioreglas';
      AppSettings.rutServicios = environment.endpoint;
      AppSettings.rutReportes = environment.endpointreportes;
      AppSettings.rutMilitarizada = environment.domainAuthorization;
      AppSettings.rutDesmilitarizada = environment.domainAuthorization + '/auth';
      AppSettings.rutDobleValidacion = environment.dobleAutenticacion;
      AppSettings.idGoogleCliente = environment.google_auth_client_id;
      AppSettings.googleMapsKey = environment.google_maps_key;
      AppSettings.tiempoInactividad = environment.tiempoInactividad;
      AppSettings.notificadorStomp = environment.notificadorStomp;
      AppSettings.unicaSessionUsuario = environment.unica_session_usuario;
      AppSettings.googleAnalyticsId = environment.google_analytics_id;
      AppSettings.url_credito_digital = environment.url_credito_digital;
      AppSettings.facetecKey = environment.facetecKey;
      AppSettings.facetecURL = environment.facetecURL;
      AppSettings.facetecPublicKey = environment.facetecPublicKey;
      AppSettings.facetecKeyProduccion = environment.facetecKeyProduccion;
      AppSettings.servidorCatpuraIpPrivada = environment.servidor_catpura_ip_privada;
      AppSettings.servidorCatpuraIp = environment.servidor_catpura_ip;
      AppSettings.clarityId = environment.clarityId;
      AppSettings.rollbaraAccessToken = environment.rollbaraAccessToken;
      AppSettings.rutFacetec = environment.endpoint + '/facetec';
      AppSettings.rutUtilidades = environment.endpoint + '/notificaciones';
      AppSettings.urlOAuthGenesys = environment.urlOAuthGenesys;
      if (objeto.LOGGIN_LEVEL && objeto.LOGGIN_LEVEL !== '${LOGGIN_LEVEL}') {
        AppSettings.loggingLevel = objeto.LOGGIN_LEVEL;
      } else {
        // Fallback para local o si el environment.ts del archivo importado tiene un nivel
        AppSettings.loggingLevel = environment.loggingLevel || 'INFO';
      }
    }
  }
}


@Injectable()
export class ConfigService {

  constructor() {
  }

  setConfig(): Promise<Config> {
    return fetch( '../assets/config.json' )
      .then( res => res.json() )
      .then( res => {
        actualizarSettingsAmbiente( res );
        // actualizarSettings( res );
        return res;
      } );
  }

}
